import Loadable from 'react-loadable';
import { RouteLoading } from './RouteLoading';

const UploadDocumentos = Loadable({
    loader: () => import('../views/Upload'),
    loading: RouteLoading,
});

const Formalizapp = Loadable({
    loader: () => import('../views/Formalizapp'),
    loading: RouteLoading,
});

const RouteUtils = [
    {
        path: '/upload/:type/:mode',
        exact: true,
        name: 'Upload de Documentos',
        component: UploadDocumentos
    },
    {
        path: '/formalizapp',
        exact: true,
        name: 'FormaliZapp',
        component: Formalizapp
    },
];

export { RouteUtils };
    